export default __webpack_public_path__ + "static/media/privacy-icon.85b65557.svg";